module.exports = __webpack_public_path__ + "static/media/Stairs_After.516cdb1f.jpg";